{
  "defaultLevel": "fast",
  "levels": {
    "fast": {
      "reasoningEffort": "none",
      "creditCost": 1,
      "maxOutputTokens": 6000,
      "retryMaxOutputTokens": 10000
    },
    "standard": {
      "reasoningEffort": "medium",
      "creditCost": 2,
      "maxOutputTokens": 10000,
      "retryMaxOutputTokens": 16000
    },
    "deep": {
      "reasoningEffort": "high",
      "creditCost": 4,
      "maxOutputTokens": 16000,
      "retryMaxOutputTokens": 22000
    }
  }
}
